.resultComponent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--bi-scale-4x);
    color: var(--bi-neutral-90);

    svg {
        color: var(--bi-alert-60);
        font-size: 8rem;

        &.success {
            color: var(--bi-success-40);
        }
    }

    p {
        font: var(--bi-font-body-large);
        text-align: center;
    }
}
